import { render } from "./start.vue?vue&type=template&id=1a44b5c5"
const script = {}

import exportComponent from "F:\\Projetos VueJs\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__